module.exports = __webpack_public_path__ + "media/images/favicons/tastee-society/favicon-0e222d23b99e8c7b91a78880dc36bd1a.ico";